const angular = require('angular');
const app = angular.module('learn-directives');
const moment = require('moment');

/**
 * Defines the content picker component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('assignContent', ['Application', 'Authorization', 'AdminUsers', 'Assignments', 'AssignmentTemplates', 'Features', '$translate', function(Application, Authorization, AdminUsers, Assignments, AssignmentTemplates, Features, $translate) {
  return {
    restrict: 'E',
    scope: {
      content: '=?',
      showHide: '=',
      clearItem: '&?',
      clearAll: '&?',
      manager: '=',
      success: '=?',
      type: '=?',
      cancel: '&?',
      file: '=?'
    },
    template: require('../../templates/directives/assign-content.html'),
    controller: ['$scope', '$window', function ($scope, $window) {
      var self = this;
      self.assignmentTemplates = Features.flags().enable_assignment_templates;
      self.authtoken = Authorization.getAuthToken();
      self.user = self.authtoken.user;
      self.content = $scope.content || [];
      self.selected_users = [];
      self.per_page = 20;
      self.selectionCount = 0;
      self.managerQuery = false;
      self.creating = false;
      self.tagsVisible = true;
      self.showConfirmRecompletionModal = false;
      self.tab = 'users'; // users | settings | preview
      if (!self.content.length) {
        self.tab = 'content';
      }
      self.tabOrder = ['content', 'users', 'settings', 'notifications', 'preview'];
      self.initialLoad = true;

      self.changeTab = function(direction, forced) {
        var add = direction === 'next' ? 1 : -1;
        var place = self.tabOrder.indexOf(self.tab);
        place = place === -1 ? 0 : place;
        if (self.tabOrder[place + add]) {
          if (self.tabOrder[place + add] !== 'content') {
            if (!self.content.length) {
              return;
            }

            if (self.tabOrder[place + add] !== 'users' && self.tabOrder[place + add] !== 'content') {
              if (self.selectionCount < 1 && !forced) {
                return;
              }
            }
          }
          if (self.tabOrder[place + add] === 'preview') {
            self.preview.page = 1;
            self.preview.getUsers();
          }
          self.tab = self.tabOrder[place + add];
        }
      };

      self.navigate = function(tab) {
        if (tab !== 'content') {
          if (!self.content.length) {
            Application.messaging.addMessage({type: 'error', duration: 5, text: 'Please add content to this assignment.'});
            return;
          }
        }
        if (tab !== 'users' && tab !== 'content') {
          if (!self.selectionCount) {
            Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['assignContent.add_users']});
            return;
          }
        }
        if (tab === 'preview') {
          self.preview.page = 1;
          self.preview.getUsers();
        }
        self.tab = tab;
      }

      self.settings = {
        non_reminder_messages: [],
        reminder_messages: [],
        overdue_messages: [],
        use_due: false,
        due_date: 30,
        due_from_hired: false,
        due_days_after_hired: 30,
        escalate_manager: false,
        escalate_buddy: false
      };

      self.import = {
        uploadId: 'open-browse',
        openBrowse: function() {
          document.getElementById(this.uploadId).click();
        },
        parseEmails: function (event) {
          let emailString = event.target.result;
          let emailsArray;
          //json
          try {
            emailsArray = JSON.parse(emailString);
          } catch (error) {
            emailsArray = emailString.split(/[ ,\r\n]+/g);
            emailsArray.forEach((email, index) => {
              emailsArray[index] = email.trim()
            });
            emailsArray = emailsArray.filter((email) => {
              return email!=='' && email!=='email'
            });
          }
          emailString = emailsArray.join(',');
          let length = emailsArray.length;
          const query = {
            fields: '_id,email',
            per_page: 10000,
            email: `$in,${length},${emailString}`
          }
          let promise = AdminUsers.findFromQuery({},query).$promise;
          promise.then(({users}) => {
            if (users.length === 0) {
              Application.messaging.addMessage({type: 'error', duration: 7, text: 'No users found. Please check user emails and see help documentation for allowed file formats'});
              return;
            }
            self.import.checkAndCount(users);
            self.changeTab('next', true);
            if(users.length !== emailsArray.length) {
              let messageText = `${users.length} of ${emailsArray.length} users have been successfully added to the assignment.`;
              Application.messaging.addMessage({type: 'info', duration: 6, text: messageText})
            }
          })
        },
        read: function() {
          const reader = new FileReader();
          reader.addEventListener('load', this.parseEmails);
          reader.readAsText($scope.file);
        },
        checkAndCount: function (users) {
          users.forEach((user) => {
            if (assignList.nin[user._id]) {
              delete assignList.nin[user._id];
            }
            assignList.in[user._id] = true;
          });
          getCount();
        }
      };

      self.addMessage = function(message) {
        // check if already in non_reminder_messages or reminder messages
        // check if type is appropriate for place
        // add to correct place
        var messageType = message.type.indexOf('reminder') !== -1 ? 'rm' : message.type.indexOf('overdue') !== -1 ? 'om' : 'nrm';
        var nrmPlace = self.settings.non_reminder_messages.indexOf(message._id);
        var rmPlace = -1;
        let omPlace = -1;
        for (const [i, rm] of self.settings.reminder_messages.entries()) {
          if (rm.message === message._id) {
            rmPlace = i;
            break;
          }
        }
        for (const [i, om] of self.settings.overdue_messages.entries()) {
          if (om.message === message._id) {
            omPlace = i;
            break;
          }
        }

        if (messageType === 'nrm') {
          if (nrmPlace === -1) {
            self.settings.non_reminder_messages.push(message._id);
          }
          if (rmPlace !== -1) {
            self.settings.reminder_messages.splice(rmPlace, 1);
          }
          if (omPlace !== -1) {
            self.settings.overdue_messages.splice(omPlace, 1);
          }
        }

        if (messageType === 'rm') {
          if (rmPlace === -1) {
            self.settings.reminder_messages.push({
              message: message._id,
              time_before_due: message.time_before_due
            });
          } else {
            self.settings.reminder_messages[rmPlace] = {
              message: message._id,
              time_before_due: message.time_before_due
            }
          }
          if (nrmPlace !== -1) {
            self.settings.non_reminder_messages.splice(nrmPlace, 1);
          }
          if (omPlace !== -1) {
            self.settings.overdue_messages.splice(omPlace, 1);
          }
        }

        if (messageType === 'om') {
          const overdueMessage = {
            message: message._id,
            cadence: message.cadence,
            total_messages: message.total_messages,
          };
          if (omPlace === -1) {
            self.settings.overdue_messages.push(overdueMessage);
          } else {
            self.settings.overdue_messages[omPlace] = overdueMessage;
          }
          if (rmPlace !== -1) {
            self.settings.reminder_messages.splice(rmPlace, 1);
          }
          if (nrmPlace !== -1) {
            self.settings.non_reminder_messages.splice(nrmPlace, 1);
          }
        }

      };

      var assignList = {
        in: {},
        nin: {},
        queries: []
      };

      self.templates = {
        create: false,
        title: ''
      };

      self.individuals = {};
      var getStandardQuery = function(){
        var q = {
          subresource: '',
          page: 1,
          per_page: self.per_page,
          fields: '_id,first_name,last_name,email,full_name,role,image,linked_locations,linked_departments,linked_teams,linked_org_level,linked_grade,job_title,last_login,createdAt,hired,manager_email',
          'linked_locations-populate': 'name',
          'linked_departments-populate': 'name',
          'linked_teams-populate': 'name',
          'linked_org_level-populate': 'name',
          'linked_grade-populate': 'name',
        };
        if ($scope.manager && $scope.manager.email) {
          q.manager_email = $scope.manager.email;
        } else {
          q.prioritize_creator = true;
        }
        return q;
      };

      self.query = getStandardQuery();

      self.initialize = function () {
        self.load();
      };

      self.load = function () {
        self.initialLoad = false;
        self.searchNext = true;
        var promise;
        if (self.managerQuery) {
          self.query.manager_query = true;
        }

        if (assignList.queries.length || assignList.in.length || assignList.nin.length) {
          var items = {};
          items.queries = assignList.queries;
          items.assignee_in = Object.keys(assignList.in);
          items.assignee_nin = Object.keys(assignList.nin);
          promise = AdminUsers.findFromQueryAndCheck({}, {find_query: self.query, match_query: items}).$promise
        } else {
          promise = AdminUsers.findFromQuery({}, self.query).$promise;
        }

        self.searchLoading = true;
        promise.then(function (results) {
          self.searchLoading = false;
          var users = results.users || [];
          self.selected_users = results.selected_users || [];
          if (users.length < self.per_page) {
            self.searchNext = false;
          }
          self.users = users;

        }).catch(function (error) {
          console.log('Error getting users:', error);
        });
      };

      self.nextPage = function() {
        if (self.lastAllSinglePage) {
          self.lastAllSinglePage = false;
          self.allChecked = false;
        }
        self.query.page++;
        self.load();
      };

      self.previousPage = function() {
        if (self.query.page <= 1) {
          return;
        }
        if (self.lastAllSinglePage) {
          self.lastAllSinglePage = false;
          self.allChecked = false;
        }
        self.query.page--;
        self.load();
      };

      self.onQuery = function(opts) {
        self.initialLoad = false;

        self.query = getStandardQuery();
        if (!opts || typeof opts === 'object' && !Object.keys(opts).length) {
          self.allChecked = false;
          self.load();
          return;
        }
        self.allChecked = false;
        self.query.page = 1;
        self.query.queries = [opts];
        self.load();
      };

      self.getLocation = function(user) {
        if (user && user.linked_locations && user.linked_locations[0] && user.linked_locations[0].name) {
          return user.linked_locations[0].name;
        }
        return '-----';
      };
      self.getDepartment = function(user) {
        if (user && user.linked_departments && user.linked_departments[0] && user.linked_departments[0].name) {
          return user.linked_departments[0].name;
        }
        return '-----';
      };
      self.getTeams = function(user) {
        if (user && user.linked_teams && user.linked_teams.length) {
          var steams = '';
          user.linked_teams.forEach(function (team) {
            steams += team.name + ', ';
          });
          return steams.slice(0, -2);
        }
        return '-----';
      };
      self.getOrgLevel = function(user) {
        if (user && user.linked_org_level) {
          return user.linked_org_level.name;
        }
        return '-----';
      };
      self.getGrade = function(user) {
        if (user && user.linked_grade) {
          return user.linked_grade.name;
        }
        return '-----';
      };

      self.preview = {
        page: 1,
        per_page: 20,
        nextAllowed: false,
        show: false,
        getUsers: function() {
          self.preview.show = true;

          var getBody = {
            fields: '_id,first_name,last_name,email,full_name,image,job_title,linked_locations,linked_departments,linked_teams,linked_org_level,linked_grade,role,hired,createdAt,last_login',
            'linked_locations-populate': 'name',
            'linked_departments-populate': 'name',
            'linked_teams-populate': 'name',
            'linked_org_level-populate': 'name',
            'linked_grade-populate': 'name',
            page: self.preview.page,
            per_page: self.preview.per_page,
            queries: assignList.queries,
            assignee_in: Object.keys(assignList.in),
            assignee_nin: Object.keys(assignList.nin)
          };

          if (self.managerQuery) {
            getBody.manager_query = true;
          }

          AdminUsers.findFromQuery({}, getBody).$promise
          .then(function(users) {
            users = users.users || [];
            self.preview.users = users;
            if (users.length < self.preview.per_page) {
              self.preview.nextAllowed = false;
              return;
            }
            self.preview.nextAllowed = true;
          });
        },
        nextPage: function() {
          self.preview.page++;
          self.preview.getUsers();
        },
        previousPage: function() {
          if (self.preview.page) {
            self.preview.page--;
            self.preview.getUsers();
          }
        }
      };

      // Functions for selecting and deselecting users to assign
      self.userClick = function(user) {
        if (self.isUserChecked(user)) {
          self.uncheckUser(user);
          return;
        }
        self.checkUser(user);
      };
      self.checkUser = function(user, id) {
        id = id ? id : user._id;
        if (assignList.nin[id]) {
          delete assignList.nin[id];
        }
        assignList.in[id] = true;
        getCount();
      };
      self.uncheckUser = function(user, id) {
        id = id ? id : user._id;
        if (assignList.in[id]) {
          delete assignList.in[id];
        }
        assignList.nin[id] = true;
        getCount();
      };

      self.lastAllSinglePage = false;
      self.selectAll = function() {
        if (self.allChecked) {

          if (self.lastAllSinglePage) {
            self.users.map(user => {
              delete assignList.in[user._id];
            });
            self.lastAllSinglePage = false;
            self.allChecked = false;
            getCount();
            return;
          }

          assignList.queries.pop();
          self.lastAllSinglePage = false;
          self.allChecked = false;
          getCount();
          return;
        };

        self.allChecked = true;
       
        if (self.query._id) {
          self.checkUser(null, self.query._id);
          self.lastAllSinglePage = false;
          return;
        }

        var queryAddition = self.query && self.query.queries && self.query.queries[0];
        if (!queryAddition) {
          self.users.map(user => {
            delete assignList.nin[user._id];
            assignList.in[user._id] = true;
          });
          getCount();
          self.lastAllSinglePage = true;
          return;
        }

        if ($scope.manager) {
          queryAddition.manager_query = true;
        }

        assignList.queries.push(queryAddition);
        getCount();

      };

      self.isUserChecked = function(user) {
        self.individuals[user._id] = false;
        if (assignList.nin[user._id]) {
          return false;
        }

        if (assignList.in[user._id]) {
          self.individuals[user._id] = true;
          return true;
        }

        if (self.allChecked) {
          self.individuals[user._id] = true;
          return true;
        }

        if (self.selected_users.indexOf(user._id) !== -1) {
          self.individuals[user._id] = true;
          return true;
        }

        return false;
      };


      var getCount = function() {
        var items = {};
        items.queries = assignList.queries;
        items.assignee_in = Object.keys(assignList.in);
        items.assignee_nin = Object.keys(assignList.nin);
        items.count_only = true;
        if (!items.queries.length && !items.assignee_in.length) {
          self.selectionCount = 0;
          return;
        }
        if (self.managerQuery) {
          items.manager_query = true;
        }
        AdminUsers.findFromQuery({}, items).$promise
        .then(function(count) {
          self.selectionCount = count.count ? count.count : 0;
        });
      };

      const typeToModel = {
        article: 'Article',
        media: 'Media',
        video: 'Media',
        file: 'Media',
        scorm: 'ScormContent',
        imported_content: 'ImportedContent',
        assessment: 'Assessment',
        workshop: 'Workshop',
        journey: 'Journey',
        track: 'Track'
      };

      self.templateBodyFromAssignment = function(body) {
        return {
          creator: self.user._id,
          title: self.templates.title,
          assigned_content: body.content.map((item) => {
            return {
              content_id: item.id,
              content_type: typeToModel[item.type]
            }
          }),
          days_to_complete: self.settings.due_date,
          due_from_hired: body.due_from_hired,
          use_days_to_complete: self.settings.use_due,
          due_days_after_hired: body.due_days_after_hired,
          escalation_contacts: body.escalation_contacts,
          escalate_manager: body.escalate_manager,
          escalate_buddy: body.escalate_buddy,
          non_reminder_messages: body.non_reminder_messages,
          reminder_messages: body.reminder_messages,
          overdue_messages: body.overdue_messages,
          require_recompletion: body.require_recompletion,
          queries: body.assignees.queries,
          in: body.assignees.assignee_in,
          nin: body.assignees.assignee_nin,
          manager_query: body.assignees.manager_query || false
        };
      };

      self.attemptCreateAssignments = async function() {
        if (self.settings.require_recompletion) {
          self.showConfirmRecompletionModal = true;
          return;
        }
        await self.createAssignments();
      }

      self.createAssignments = async function() {

        if (self.templates.create && !self.templates.title) {
          Application.messaging.addMessage({type: 'error', duration: 6, text: 'Please add template title before creating assignment.'});
          return;
        }

        self.creating = true;
        var user = Authorization.getAuthToken().user._id;
        var content = [];
        for (var i = 0; i < self.content.length; i++) {
          var item = {};
          if (self.content[i].type === 'article') {
            item.type = 'article';
          }
          if (self.content[i].type === 'video' || self.content[i].type === 'file') {
            item.type = 'media';
          }
          if (self.content[i].type === 'scorm') {
            item.type = 'scorm';
          }
          if (self.content[i].type === 'imported_content') {
            item.type = 'imported_content';
          }
          if (self.content[i].type === 'assessment') {
            item.type = 'assessment';
          }
          if (self.content[i].type === 'workshop' || self.content[i].type === 'multi_session_workshop') {
            item.type = 'workshop';
          }
          if (self.content[i].type === 'journey') {
            item.type = 'journey';
          }
          if (!self.content[i].type || self.content[i].type === 'track') {
            item.type = 'track';
          }
          item.id = self.content[i]._id;
          content.push(item);
        }

        if (!user) {
          return;
        }
        var body = {
          assignees: {},
          assigner: user,
          content: content,
          reminder_messages: self.settings.reminder_messages,
          non_reminder_messages: self.settings.non_reminder_messages,
          overdue_messages: self.settings.overdue_messages,
          escalation_contacts: self.settings.escalation_contacts || [],
          escalate_manager: self.settings.escalate_manager || false,
          escalate_buddy: self.settings.escalate_buddy || false,
          due_from_hired: self.settings.due_from_hired || false,
          due_days_after_hired: self.settings.due_days_after_hired || 0,
          require_recompletion: self.settings.require_recompletion || false,
        };

        if (self.settings.use_due && self.settings.due_date) {
          body.due_date = new Date(moment().add(self.settings.due_date, 'days').valueOf());
        }
        
        if (body.overdue_messages?.length && !body.due_date) {
          Application.messaging.addMessage({type: 'error', duration: 5, text: self.translations['assignContent.overdue_due_date']});
          self.creating = false;
          return;
        }

        body.assignees.queries = assignList.queries;
        body.assignees.assignee_in = Object.keys(assignList.in);
        body.assignees.assignee_nin = Object.keys(assignList.nin);

        if (self.managerQuery) {
          body.assignees.manager_query = true;
        }

        try {
          if (self.templates.create) {
            const templateBody = self.templateBodyFromAssignment(body);

            await AssignmentTemplates.createAndDistribute({}, templateBody).$promise

          } else {
            await Assignments.queryCreate({}, body).$promise
          }
          // must apply scope so su-modal dismounts correctly and doesn't leave page dimmed
          self.showConfirmRecompletionModal = false;
          $scope.$apply();
          
          Application.messaging.addMessage({type: 'success', duration: 5, text: self.translations['manage.assign.content_confirmMessage'] });
          self.preview.show = false;
          self.clearChoices();
          $scope.success = true;
          self.creating = false;
          $scope.showHide = false;
          if ($scope.cancel) {
            $scope.cancel();
          }
          // Required due to the async.
          $scope.$apply();
        } catch (error) {
          console.log('Error in creating Assignments: ', error);
          if (error && error.data.errors) {
            Application.messaging.renderApiResponseErrorCodes(error.data, {
              REQUIRE_RECOMPLETION_TYPE_DISALLOWED: self.translations["assignment.errors.create.REQUIRE_RECOMPLETION_TYPE_DISALLOWED"]
            });
            self.showConfirmRecompletionModal = false;
            self.creating = false;
            $scope.showHide = false;
            $scope.$apply();
          }
        }


      };

      // End functions for selecting and deselecting users to assign
      self.clearChoices = function() {
        assignList = {
          in: {},
          nin: {},
          queries: []
        };
        self.individuals = {};
        self.selectionCount = 0;
        self.allChecked = false;
        self.clearQuery = true;
        // $scope.clearAll();
      };
      self.cancel = function() {
        if ($scope.cancel) {
          $scope.cancel();
          return;
        }
        $scope.showHide = false;
        // self.clearChoices();
      };
      self.removeContent = function(index) {
        // $scope.clearItem({item: self.content[index]});
        // if (!self.content.length) {
        //   self.cancel();
        // }
      };
      self.resizeWindow = function() {
        var modal = document.querySelector('.assignment--admin');
        var modalHeight = document.querySelector('.assignment--admin').clientHeight;
        var modalPadding = $window.getComputedStyle(modal).paddingBottom;
        var searchHeight = document.querySelector('.assignment--admin .usersearch').clientHeight;
        var stepbarHeight = document.querySelector('.assignment--admin .stepbar').clientHeight;
        var assignedboxHeight = document.querySelector('.assignment--admin__currentlyassigned').clientHeight;
        var newHeight = modalHeight -  (parseInt(modalPadding.replace('px','')) * 3) - searchHeight - stepbarHeight - assignedboxHeight;
        self.windowHeight = newHeight;
      };
      angular.element($window).bind('resize', function() {
        self.resizeWindow();
        $scope.$apply();
      });
      $scope.$on('$destroy', function () {
        angular.element($window).unbind('resize');
      });

      $scope.$watch('file', function(newVal, oldVal) {
        oldVal = oldVal || {};
        if (!newVal || typeof newVal !== 'object') {
          return;
        }
        if (newVal.name && newVal.name !== oldVal.name) {
          Application.messaging.addMessage({type: 'success', duration: 5, text: `"${$scope.file.name}" Imported Successfully`});
          self.import.read()
        }
      });

      if ($scope.manager && $scope.manager.email) {
        // **TODO ** Possibly send email data through this
        self.managerQuery = true;
      }

      if ((!self.users || !self.users.length) && $scope.manager) {
        self.query = getStandardQuery();
        self.load();
      }

      setTimeout(function() {
        // settimeout is necessary to take affect after elements have been resized
        self.resizeWindow();
        $scope.$apply();
      }, 100);

      $translate([
        'manage.assign.content_confirmMessage',
        'assignContent.search_placeholder',
        'assignContent.add_users',
        'edit.useradd.success_csv',
        'assignContent.overdue_due_date',
        'assignment.errors.create.REQUIRE_RECOMPLETION_TYPE_DISALLOWED'
      ]).then(function(translations){
        self.translations = translations;
      });

    }],
    controllerAs: 'assignments'
  };
}]);
